'use client';
import { create } from 'zustand';
import { CustomerSubscription, SubscriptionsOptions } from '../types';

type SubscriptionState = {
  customerSubscription: CustomerSubscription | null;
  setCustomerSubscription: (cs: CustomerSubscription | null) => void;
  subscriptionsOptions: SubscriptionsOptions | null;
  setSubscriptionsOptions: (cs: SubscriptionsOptions | null) => void;
  openSubscriptionModal: boolean;
  toggleOpenSubscriptionModal: () => void;
  subscriptionsLoading: boolean;
  setSubscriptionsLoading: (loading: boolean) => void;
};

export const useSubscriptionStore = create<SubscriptionState>((set) => ({
  customerSubscription: null,
  setCustomerSubscription: (customerSubscription) => set({ customerSubscription }),
  subscriptionsOptions: null,
  setSubscriptionsOptions: (subscriptionsOptions) => set({ subscriptionsOptions }),
  openSubscriptionModal: false,
  toggleOpenSubscriptionModal: () =>
    set((state) => ({ openSubscriptionModal: !state.openSubscriptionModal })),
  subscriptionsLoading: true,
  setSubscriptionsLoading: (loading) => set({ subscriptionsLoading: loading }),
}));
